/**
 * Cross-cutting API error codes that have a translation under `errors.api.<CODE>` in every locale.
 *
 * The canonical list lives in `@ibada/shared-types/errors` so the backend and frontend agree on the
 * same code names; this module re-exports it and adds the frontend-only i18n namespace constant.
 * Per-feature domain codes live under `<feature>.errors.<CODE>` and are not listed here.
 */
export {
  SHARED_API_ERROR_CODES,
  SHARED_API_ERROR_CODE_SET,
  type SharedApiErrorCode,
} from "@ibada/shared-types/errors"

/** i18n namespace that holds the shared generic messages (`errors.api.<CODE>`). */
export const SHARED_API_ERROR_NS = "errors.api"
